import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';

import { EffectsModule } from '@ngrx/effects';
import { StoreModule } from '@ngrx/store';

import { DatapointFieldEffects } from './datapoint-field.effects';
import { reducer } from './datapoint-field.reducer';

@NgModule({
  imports: [
    CommonModule,
    StoreModule.forFeature('datapointField', reducer),
    EffectsModule.forFeature([DatapointFieldEffects]),
  ],
  providers: [DatapointFieldEffects],
})
export class DatapointFieldStoreModule {}
